import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './app/App';
import registerServiceWorker from './registerServiceWorker';
import { BrowserRouter as Router } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import Locale from './common/Locale';

ReactDOM.render(
  <Router>
    <Locale>
      <App />
    </Locale>
  </Router>,
  document.getElementById('root'),
);

registerServiceWorker();
